const React = require('react')
const { useState } = require('react')
const { useLocation } = require('react-router-dom')
const { Row, Col, Card, CardHeader, CardBody, Collapse, FormGroup, FormFeedback, Label, Input } = require('reactstrap')
const { useNetworkConfig } = require('@contexts')

require('@styles/pages/verifyContract/index.css')

const UploadContract = props => {
    const { sourceCode, setSourceCode, errorMessage, setErrorMessage } = props
    const { network } = useNetworkConfig()
    const location = useLocation()
    const params = new URLSearchParams(location.search)

    const contractAddress = params.get('a')
    const compilerVersion = params.get('c')

    const [isSourceCodeOpen, setIsSourceCodeOpen] = useState(true)

    const handleSourceCodeChange = e => {
        const value = e.target.value
        setSourceCode(value)

        if (value.trim() === '') {
            setErrorMessage('Required')
        } else {
            setErrorMessage('')
        }
    }

    return (
        <Card className='box table-section' style={{ padding: '0px', border: 'none' }}>
            <CardHeader
                className='verify-card-header cursor-pointer'
                onClick={() => setIsSourceCodeOpen(!isSourceCodeOpen)}
                style={{
                    border: !isSourceCodeOpen && 'none',
                    borderColor: isSourceCodeOpen && 'var(--dropdown-background)'
                }}
            >
                <span style={{ fontWeight: 'bold' }}>Upload Contract Source Code</span>
                <i className={`fas fa-angle-${isSourceCodeOpen ? 'up' : 'down'}`} />
            </CardHeader>
            <Collapse isOpen={isSourceCodeOpen}>
                <CardBody>
                    <div style={{ marginBottom: '8px' }}>
                        1. If the contract compiles correctly at&nbsp;
                        <span
                            className={`${network.name}-text-color cursor-pointer`}
                            onClick={() => window.open('https://remix.ethereum.org/', '_blank')}
                        >
                            REMIX
                        </span>
                        , it should also compile correctly here.
                    </div>
                    <div style={{ marginBottom: '8px' }}>
                        2. We have limited support for verifying contracts created by another contract and there is a
                        timeout of up to 45 seconds for each contract compiled.
                    </div>
                    <div>
                        3. For programatic contract verification, check out the{' '}
                        <span
                            className={`${network.name}-text-color cursor-pointer`}
                            onClick={() => window.open('https://docs.etherscan.io/api-endpoints/contracts', '_blank')}
                        >
                            Contract API Endpoint
                        </span>
                        .
                    </div>
                    <div
                        style={{
                            backgroundColor: 'var(--dropdown-background)',
                            borderRadius: '8px',
                            padding: '16px',
                            margin: '16px 0'
                        }}
                    >
                        <Row style={{ marginBottom: '8px' }}>
                            <Col xs='3' style={{ color: 'var(--grey-color)' }}>
                                Contract Address:
                            </Col>
                            <Col
                                xs='9'
                                className={`${network.name}-text-color cursor-pointer`}
                                style={{ fontWeight: 'bold' }}
                                onClick={() => {
                                    const url = `/${network.name}/address/${contractAddress}`
                                    window.open(window.location.origin + url, '_blank')
                                }}
                            >
                                {contractAddress}
                            </Col>
                        </Row>
                        <Row style={{ marginBottom: '8px' }}>
                            <Col xs='3' style={{ color: 'var(--grey-color)' }}>
                                Compiler Type:
                            </Col>
                            <Col xs='9' style={{ fontWeight: 'bold' }}>
                                SINGLE FILE / CONCATENATED METHOD
                            </Col>
                        </Row>
                        <Row>
                            <Col xs='3' style={{ color: 'var(--grey-color)' }}>
                                Compiler Version:
                            </Col>
                            <Col xs='9' style={{ fontWeight: 'bold' }}>
                                {compilerVersion}
                            </Col>
                        </Row>
                    </div>
                    <FormGroup>
                        <Label style={{ fontWeight: 'bold' }}>Enter the Solidity Contract Code below</Label>
                        <Input
                            type='textarea'
                            rows='15'
                            value={sourceCode}
                            onChange={handleSourceCodeChange}
                            invalid={!!errorMessage}
                            required
                            style={{
                                border: 'none',
                                whiteSpace: 'pre',
                                overflowX: 'auto',
                                resize: 'vertical',
                                backgroundColor: 'var(--dropdown-background)',
                                color: 'var(--white-color)'
                            }}
                        />
                        {errorMessage && <FormFeedback>{errorMessage}</FormFeedback>}
                    </FormGroup>
                </CardBody>
            </Collapse>
        </Card>
    )
}

module.exports = { UploadContract }
